import React, { useState, useEffect } from 'react';
import { AutoComplete } from "antd";

import './CronDifferentSetting.scss';

let DiffSettingUserGroups = [];
let ConversionInfos = null;
const plans = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const Country = `AD\t安道尔共和国\tAndorra,AE\t阿拉伯联合酋长国\tUnited Arab Emirates,AF\t阿富汗\tAfghanistan,AG\t安提瓜和巴布达\tAntigua and Barbuda\t,AI\t安圭拉岛\tAnguilla\t,AL\t阿尔巴尼亚\tAlbania\t,AM\t亚美尼亚\tArmenia\t,AC \t阿森松\tAscension\t,AO\t安哥拉\tAngola\t,AR\t阿根廷\tArgentina,AT\t奥地利\tAustria,AU\t澳大利亚\tAustralia,AZ\t阿塞拜疆\tAzerbaijan\t,BB\t巴巴多斯\tBarbados,BD\t孟加拉国\tBangladesh\t,BE\t比利时\tBelgium,BF\t布基纳法索\tBurkina-faso\t,BG\t保加利亚\tBulgaria,BH\t巴林\tBahrain,BI\t布隆迪\tBurundi,BJ\t贝宁\tBenin,PS\t巴勒斯坦\tPalestine,BM\t百慕大群岛\tBermuda Is.\t,BN\t文莱\tBrunei\t,BO\t玻利维亚\tBolivia\t,BR\t巴西\tBrazil,BS\t巴哈马\tBahamas\t,BW\t博茨瓦纳\tBotswana\t,BY\t白俄罗斯\tBelarus\t,BZ\t伯利兹\tBelize\t,CA\t加拿大\tCanada\t,KY\t开曼群岛\tCayman Is.\t,CF\t中非共和国\tCentral African Republic\t,CG\t刚果\tCongo\t,CH\t瑞士\tSwitzerland,CK\t库克群岛\tCook Is.\t,CL\t智利\tChile,CM\t喀麦隆\tCameroon\t,CN\t中国\tChina,CO\t哥伦比亚\tColombia,CR\t哥斯达黎加\tCosta Rica\t,CS\t捷克\tCzech\t,CU\t古巴\tCuba,CY\t塞浦路斯\tCyprus,CZ\t捷克\tCzech Republic,DE\t德国\tGermany,DJ\t吉布提\tDjibouti\t,DK\t丹麦\tDenmark,DO\t多米尼加共和国\tDominica Rep.,DZ\t阿尔及利亚\tAlgeria,EC\t厄瓜多尔\tEcuador,EE\t爱沙尼亚\tEstonia,EG\t埃及\tEgypt,ES\t西班牙\tSpain,ET\t埃塞俄比亚\tEthiopia\t,FI\t芬兰\tFinland\t,FJ\t斐济\tFiji,FR\t法国\tFrance,GA\t加蓬\tGabon\t,GB\t英国\tUnited Kiongdom,GD\t格林纳达\tGrenada\t,GE\t格鲁吉亚\tGeorgia\t,GF\t法属圭亚那\tFrench Guiana,GH\t加纳\tGhana,GI\t直布罗陀\tGibraltar,GM\t冈比亚\tGambia\t,GN\t几内亚\tGuinea\t,GR\t希腊\tGreece,GT\t危地马拉\tGuatemala\t,GU\t关岛\tGuam,GY\t圭亚那\tGuyana,HK\t中国香港特别行政区\tHongkong,HN\t洪都拉斯\tHonduras,HT\t海地\tHaiti,HU\t匈牙利\tHungary,ID\t印度尼西亚\tIndonesia,IE\t爱尔兰\tIreland,IL\t以色列\tIsrael,IN\t印度\tIndia,IQ\t伊拉克\tIraq,IR\t伊朗\tIran,IS\t冰岛\tIceland,IT\t意大利\tItaly,CI\t科特迪瓦\tIvory Coast,JM\t牙买加\tJamaica,JO\t约旦\tJordan,JP\t日本\tJapan,KE\t肯尼亚\tKenya,KG\t吉尔吉斯坦\tKyrgyzstan,KH\t柬埔寨\tKampuchea (Cambodia ),KP\t朝鲜\tNorth Korea,KR\t韩国\tKorea,KW\t科威特\tKuwait,KZ\t哈萨克斯坦\tKazakstan,LA\t老挝\tLaos,LB\t黎巴嫩\tLebanon,LC\t圣卢西亚\tSt.Lucia,LI\t列支敦士登\tLiechtenstein,LK\t斯里兰卡\tSri Lanka,LR\t利比里亚\tLiberia,LS\t莱索托\tLesotho,LT\t立陶宛\tLithuania,LU\t卢森堡\tLuxembourg,LV\t拉脱维亚\tLatvia,LY\t利比亚\tLibya,MA\t摩洛哥\tMorocco,MC\t摩纳哥\tMonaco,MD\t摩尔多瓦\tMoldova, Republic of,MG\t马达加斯加\tMadagascar,ML\t马里\tMali,MM\t缅甸\tBurma,MN\t蒙古\tMongolia,MO\t中国澳门特别行政区\tMacao,MS\t蒙特塞拉特岛\tMontserrat Is,MT\t马耳他\tMalta,MP\t马里亚那群岛\tMariana Is,MQ\t马提尼克\tMartinique,MU\t毛里求斯\tMauritius,MV\t马尔代夫\tMaldives,MW\t马拉维\tMalawi,MX\t墨西哥\tMexico,MY\t马来西亚\tMalaysia,MZ\t莫桑比克\tMozambique,NA\t纳米比亚\tNamibia,NE\t尼日尔\tNiger,NG\t尼日利亚\tNigeria,NI\t尼加拉瓜\tNicaragua,NL\t荷兰\tNetherlands,NO\t挪威\tNorway,NP\t尼泊尔\tNepal,AN\t荷属安的列斯\tNetheriands Antilles,NR\t瑙鲁\tNauru,NZ\t新西兰\tNew Zealand,OM\t阿曼\tOman,PA\t巴拿马\tPanama,PE\t秘鲁\tPeru,PF\t法属玻利尼西亚\tFrench Polynesia,PG\t巴布亚新几内亚\tPapua New Cuinea,PH\t菲律宾\tPhilippines,PK\t巴基斯坦\tPakistan,PL\t波兰\tPoland,PR\t波多黎各\tPuerto Rico,PT\t葡萄牙\tPortugal,PY\t巴拉圭\tParaguay,QA\t卡塔尔\tQatar,RE\t留尼旺\tReunion,RO\t罗马尼亚\tRomania,RU\t俄罗斯\tRussia,SA\t沙特阿拉伯\tSaudi Arabia,SB\t所罗门群岛\tSolomon Is,SC\t塞舌尔\tSeychelles,SD\t苏丹\tSudan,SE\t瑞典\tSweden,SG\t新加坡\tSingapore,SI\t斯洛文尼亚\tSlovenia,SK\t斯洛伐克\tSlovakia,SL\t塞拉利昂\tSierra Leone,SM\t圣马力诺\tSan Marino,AS\t东萨摩亚(美)\tSamoa Eastern,WS\t西萨摩亚\tSan Marino,SN\t塞内加尔\tSenegal,SO\t索马里\tSomali,SR\t苏里南\tSuriname,ST\t圣多美和普林西比\tSao Tome and Principe,SV\t萨尔瓦多\tEI Salvador,SY\t叙利亚\tSyria,SZ\t斯威士兰\tSwaziland,TD\t乍得\tChad,TG\t多哥\tTogo,TH\t泰国\tThailand,TJ\t塔吉克斯坦\tTajikstan,TM\t土库曼斯坦\tTurkmenistan,TN\t突尼斯\tTunisia,TO\t汤加\tTonga,TR\t土耳其\tTurkey,TT\t特立尼达和多巴哥\tTrinidad and Tobago,TW\t中国台湾省\tTaiwan,TZ\t坦桑尼亚\tTanzania,UA\t乌克兰\tUkraine,UG\t乌干达\tUganda,US\t美国\tUnited States of America,UY\t乌拉圭\tUruguay\t,UZ\t乌兹别克斯坦\tUzbekistan\t,VC\t圣文森特岛\tSaint Vincent,VE\t委内瑞拉\tVenezuela,VN\t越南\tVietnam,YE\t也门\tYemen\t,YU\t南斯拉夫\tYugoslavia,ZA\t南非\tSouth Africa,ZM\t赞比亚\tZambia,ZR\t扎伊尔\tZaire,ZW\t津巴布韦\tZimbabwe`.split(',').map((item)=>{
    item = item.split('\t');
    return item[0] + '-' + item[1] + `(${item[2]})`
});
let CurrentPlan = 'planA';
let allPlatformList = [];


const CrontabDifferentSetting = () => {
    const [platformAutoComplete, setPlatformAutoComplete] = useState([]);

    useEffect(() => {
        queryAllPlatform();
    }, []);
    /**
     * 获得某平台的Cron配置
     * 并且更新菜单
     * @param {*} platform
     * @param   plan
     */
    async function queryDiffConfig(platform, plan) {
        return new Promise(async (resolve, reject) => {
            if (!platform) {
                alert("缺少平台名");
                return;
            }

            let username = localStorage.getItem("username");
            let menuId = $("#menu_id").html();
            // 获得所有config
            $.ajax({
                type: "GET",
                url: "/api/v1/cron_diff_config/single_config?platform=" + platform + "&plan=" + plan + '&username=' + username + '&menuId=' + menuId,
                success: function(data) {
                    if (!data || data.err) {
                        if (data.isReload) {
                            window.location.href = "/login.html";
                            return;
                        }
                        alert("Query Failed：" + data.err);
                        reject(data.err);
                    } else {
                        resolve(data.data);
                    }
                },
                error: function(req, status, err) {
                    const message = err.message || err;
                    alert("查询配置失败，网络出问题了，请稍后重试。错误原因:" + message);
                    reject(err);
                },
            });
        });
    }


    /**
     * 点击更新按键时，更新菜单
     * + 更新输入框中的内容
     */
    async function refresh() {
        await refresh_different_setting_group();
        await refresh_crontab_rule()
    }

/////////////////////////////////////////////////////////////////////////////////////
// 网络请求函数
/////////////////////////////////////////////////////////////////////////////////////


    /**
     * 拉取所有平台名称
     * @returns {Promise<void>}
     */
    async function queryAllPlatform() {
        let username = localStorage.getItem("username");
        let menuId = $("#menu_id").html();
        $.ajax({
            type: "GET",
            url: "/api/v1/config/diff_platform?username=" + username + '&menuId=' + menuId,
            success: function(data) {
                if (data.err) {
                    if (data.isReload) {
                        window.location.href = "./login.html";
                    } else {
                        alert(data.err);
                    }
                    return;
                }
                data = data.data;
                if (data && Object.keys(data).length > 0) {
                    allPlatformList = Object.keys(data);
                }
            },
            error: function(req, status, err) {
                const message = err.message || err;
                alert("查询失败，网络出问题了，请稍后重试。错误原因:" + message);
            },
        });
    }


    function initGroupData(af_status, campain_id, channels, country) {
        $("#combox1").combox({
            id: "id",
            name: "text",
            data: af_status,
        });
        $("#combox2").combox({
            id: "id",
            name: "text",
            data: campain_id,
            valueChange:function(data){
                // debugger
                const selectedData = data.selectData;
                const selectedMedias = [];
                for (const data of selectedData) {
                    const campaign = data.id;
                    const parent = ConversionInfos.campaign_id[campaign].parents[0];
                    selectedMedias.push(parent)
                }
                const medias = Object.keys(ConversionInfos.media_source).map((item) => {
                    return {id: item, text: item}
                });
                for (const media of medias) {
                    if (selectedMedias.includes(media.id)) {
                        if (!$("#"+ media.id).hasClass("checked")) {
                            $("#"+ media.id).mousedown();
                        }
                    }
                }
            }
        });
        $("#combox3").combox({
            id: "id",
            name: "text",
            data : channels,
            valueChange:function(data){
                // debugger
                const selectedData = data.selectData;
                const selectedAfs = [];
                for (const data of selectedData) {
                    const media = data.id;
                    const parent = ConversionInfos.media_source[media].parents[0];
                    selectedAfs.push(parent)
                }
                const afInfos = Object.keys(ConversionInfos.af_status).map((item) => {
                    return {id: item, text: item}
                });
                for (const af of afInfos) {
                    if (selectedAfs.includes(af.id)) {
                        if (!$("#"+af.id).hasClass("checked")) {
                            $("#"+af.id).mousedown();
                        }
                    }
                }
            }
        });
        $("#combox4").combox({
            id: "id",
            name: "text",
            data: country,
        });
        $(".combox").removeAttr("readonly");
    }


    function save_diff_setting_user_group() {
        let af_status = $("#combox1").data('combox').options.selectData;
        let campain_id = $("#combox2").data('combox').options.selectData;
        let media_source = $("#combox3").data('combox').options.selectData;
        let country = $("#combox4").data('combox').options.selectData;

        // const campaign_t = $(":input[name='campaign_t']:checked").val();
        const country_t = $(":input[name='country_t']:checked").val();

        let groupInfo = {};

        function getValue(l) {
            return l.map((item) => {
                return item.id
            })
        }
        if (af_status.length > 0) {
            groupInfo.af_status = getValue(af_status);
        }
        if (media_source.length > 0) {
            groupInfo.media_source = getValue(media_source);
        }
        if (campain_id.length > 0) {
            groupInfo.campaign_id = getValue(campain_id);
        }
        if (country.length > 0) {
            groupInfo.country = getValue(country);
        }

        // if (campaign_t === 'negative') {
        //     groupInfo.campaign_id = groupInfo.campaign_id.map((item) => {
        //         return '!' + item;
        //     })
        // }

        if (country_t === 'negative') {
            groupInfo.country = groupInfo.country.map((item) => {
                return '!' + item;
            })
        }

        const platform = $("#platform_input").val();
        const plan = CurrentPlan;
        if (!platform || !plan || !groupInfo) {
            alert('lack plan、platform or group_info');
            return
        }
        console.log(groupInfo);
        let username = localStorage.getItem("username");
        $.ajax({
            type: "POST",
            url: "/api/v1/cron_diff_config/config?username=" + username + "&menuId=setting",
            data: {
                platform,
                plan,
                setting_name: 'group_info',
                setting_value: JSON.stringify(groupInfo)
            },
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("提交失败：" + data.err);
                }
                refresh_different_setting_group();
            },
            error: function (req, status, err) {
                const message = err.message || err;
                alert("保存用户分组失败，网络出问题了，请稍后重试。错误原因:" + message);
                refresh_different_setting_group();
            },
        });
    }

    async function refresh_different_setting_group() {
        $("#userGroupSelect").show();
        $("#submit_different_setting_user_group").show();

        const platform = $("#platform_input").val();
        if (!platform) {
            alert("请选择platform");
            return;
        }
        let username = localStorage.getItem("username");

        $.ajax({
            type: "GET",
            url: "/api/v1/cron_diff_config/get_diff_setting_user_groups/?username=" + username + `&menuId=setting&platform=${platform}`,
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("提交失败：" + data.err);
                } else if (data.status === 200) {
                    DiffSettingUserGroups = data.groups;
                    initCombox();
                    let group = {};
                    for (const userGroup of DiffSettingUserGroups) {
                        if (userGroup.plan_name === CurrentPlan) {
                            group = userGroup;
                            break;
                        }
                    }
                    showGroupDiff(group)
                } else {
                    const message = data.err || err;
                    console.log(message);
                    alert("查询用户分组，网络出问题了，请稍后重试");
                }
            },
            error: function (req, status, err) {
                alert("request failed.[err: " + err + "]  ಠ_ಠ");
            },
        });
        await init_switch(platform);
        $("#switch_mod").show();
        $("#different_config_group").show()
    }


    function initCombox() {
        $("#userGroupSelect").empty();
        $("#userGroupSelect").append(
            `<div class="card" style="width: 100%;position: relative">
            <div style="height: 50px;">
                af_status: <input class="combox" style="position: absolute;left: 300px; width: 400px;" name="af_status" id="combox1" autocomplete="off">
            </div>
            <div style="height: 50px;">
                media_source: <input class="combox" style="position: absolute;left: 300px; width: 400px;" name="media_source" id="combox3" autocomplete="off">
            </div>
            <div style="height: 50px;">
                campain_id: <input class="combox" style="position: absolute;left: 300px; width: 400px;" name="campain_id" id="combox2" autocomplete="off">
            </div>
            <div style="height: 50px;">
                country: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;<input type="radio" checked="checked"  name="country_t" value="positive"> 正选 &nbsp;<input type="radio" name="country_t" value="negative"> 反选 <input class="combox" style="position: absolute;left: 300px; width: 400px;" name="country" id="combox4" autocomplete="off">
            </div>
        </div>`
        )
    }

    function showGroupDiff(userGroup) {
        if (!userGroup) {
            userGroup = {};
        }
        const groupInfo = userGroup.group_info;
        let country_t = 'positive';
        if (groupInfo && groupInfo.country && groupInfo.country.length > 0) {
            for (const country of groupInfo.country) {
                if (country.indexOf('!') > -1) {
                    country_t = 'negative';
                    const index = groupInfo.country.indexOf(country);
                    groupInfo.country[index] = country.replace('!', '');
                }
            }
        }
        if (country_t === 'negative') {
            $(":input[name='country_t']")[1].click();
        } else {
            $(":input[name='country_t']")[0].click();
        }

        let username = localStorage.getItem("username");
        const platform = $("#platform_input").val();
        if (!platform) {
            alert('请选择platform');
            return;
        }
        $.ajax({
            type: "GET",
            url: "/api/v1/config/get_diff_setting_af_infos?username=" + username + `&menuId=setting&platform=${platform}`,
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("request failed：" + data.err);
                }
                else if (data.status === 200) {
                    ConversionInfos = data.data.afInfos;
                    const af_status = Object.keys(data.data.afInfos.af_status).map((item) => {
                        return {id: item, text: item}
                    });
                    const media_source = Object.keys(data.data.afInfos.media_source).map((item) => {
                        return {id: item, text: item + `(${data.data.afInfos.media_source[item].parents[0]})`}
                    });
                    const campaign_id = Object.keys(data.data.afInfos.campaign_id).map((item) => {
                        return {id: item, text: item + `(${data.data.afInfos.campaign_id[item].parents[0]})`}
                    });
                    const country = Country.map((item) => {
                        const splitItem = item.split('-');
                        return {id: splitItem[0], text: splitItem[1]}
                    });
                    for (const af of af_status) {
                        if (groupInfo && groupInfo.af_status && groupInfo.af_status.includes(af.id)) {
                            af.checked = true
                        }
                    }
                    for (const af of campaign_id) {
                        if (groupInfo && groupInfo.campaign_id && groupInfo.campaign_id.includes(af.id)) {
                            af.checked = true
                        }
                    }
                    for (const af of media_source) {
                        if (groupInfo && groupInfo.media_source && groupInfo.media_source.includes(af.id)) {
                            af.checked = true
                        }
                    }
                    for (const ct of country) {
                        if (groupInfo && groupInfo.country && groupInfo.country.includes(ct.id)) {
                            ct.checked = true
                        }
                    }

                    initGroupData(af_status, campaign_id, media_source, country)
                }
            },
            error: function (req, status, err) {
                const message = err.message || err;
                alert("展示用户分组失败，网络出问题了，请稍后重试。错误原因:" + message);
            },
        });
    }


    async function init_switch(platform) {
        const cron_diff_setting = await queryDiffConfig(platform, CurrentPlan);
        const crontab_enabled = cron_diff_setting.crontabEnabled;
        const icon = $("#switch-icon");
        if (crontab_enabled === 'on') {
            $('#switch-text').html('已启用');
            if (icon.hasClass("fa-toggle-off")) {
                icon.removeClass("fa-toggle-off");
                icon.addClass("fa-toggle-on")
            }
            $("#switch").val("on");
            $("#confirm").html("定时器已启用，是否要停用？")
        } else {
            $('#switch-text').html('已停用');
            if (icon.hasClass("fa-toggle-on")) {
                icon.removeClass("fa-toggle-on");
                icon.addClass("fa-toggle-off")
            }
            $("#switch").val("off");
            $("#confirm").html("定时器已停用，是否要启用？");
        }
    }

    function switchStatus (){
        let platform = $("#platform_input").val();
        if (!platform) {
            platform = $("#platform_input").val();
        }
        if (!platform) {
            alert("请选择platform");
            return;
        }

        let switchStatus = $("#switch").val();
        switchStatus = switchStatus === 'on' ? 'off' : 'on';

        // 获取switch
        let username = localStorage.getItem("username");
        $.ajax({
            type: "POST",
            url: "/api/v1/cron_diff_config/config?username=" + username + `&menuId=setting&platform=${platform}`,
            data: {
                platform,
                plan: CurrentPlan,
                setting_name: 'crontab_enabled',
                setting_value: switchStatus,
            },
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("提交失败：" + data.err);
                } else if (data.status === 200) {
                    init_switch(platform);
                } else {
                    alert(data.message);
                }
            },
            error: function (req, status, err) {
                const message = err.message || err;
                alert("开启或者停用差异化配置失败，网络出问题了，请稍后重试。错误原因:" + message);
            },
        });
    }

    async function refresh_crontab_rule() {
        $("#crontab_rule_select").show();
        $("#submit_crontab_rule").show();

        const platform = $("#platform_input").val();
        if (!platform) {
            alert("请选择platform");
            return;
        }
        const cron_diff_setting = await queryDiffConfig(platform, CurrentPlan);
        const crontab_rule = (cron_diff_setting && cron_diff_setting.crontabRule) || {};
        let start_day_of_week = '';
        let start_hour_of_day = '';
        let end_day_of_week = '';
        let end_hour_of_day = '';
        if (Object.keys(crontab_rule).length > 0) {
            const { start, end } = crontab_rule;
            start_day_of_week = start.day;
            start_hour_of_day = start.hour;
            end_day_of_week = end.day;
            end_hour_of_day = end.hour;
        }
        const days = {
            '星期一': 1,
            '星期二': 2,
            '星期三': 3,
            '星期四': 4,
            '星期五': 5,
            '星期六': 6,
            '星期日': 7,
        };
        const hours = {
            '0': 0,
            '1': 1,
            '2': 2,
            '3': 3,
            '4': 4,
            '5': 5,
            '6': 6,
            '7': 7,
            '8': 8,
            '9': 9,
            '10': 10,
            '11': 11,
            '12': 12,
            '13': 13,
            '14': 14,
            '15': 15,
            '16': 16,
            '17': 17,
            '18': 18,
            '19': 19,
            '20': 20,
            '21': 21,
            '22': 22,
            '23': 23,
        };
        const startHtml = generateHtml(days, hours, start_day_of_week, start_hour_of_day);
        const endHtml = generateHtml(days, hours, end_day_of_week, end_hour_of_day);

        const selectHtml = `<div class="card" style="width: 100%;position: relative">
                            <div style="height: 50px;">开始时间:
                             <select id="start_day_of_week" style="width: 100px; position: absolute; left: 300px"> 
                                    ${startHtml.daySelectHtml} 
                             </select>
                             <select id="start_hour_of_day" style="width: 100px; position: absolute; left: 450px">
                                    ${startHtml.hourSelectHtml}
                             </select>
                            </div>
                            <div style="height: 50px;">结束时间: 
                            <select id="end_day_of_week" style="width: 100px; position: absolute; left: 300px">
                                    ${endHtml.daySelectHtml} 
                            </select>
                            <select id="end_hour_of_day" style="width: 100px; position: absolute; left: 450px">
                                    ${endHtml.hourSelectHtml}
                            </select>
                            </div>
                        </div>`;
        $("#crontab_rule_select").empty();
        $("#crontab_rule_select").html(selectHtml);
    }

    function generateHtml (days, hours, rule_day, rule_hour) {
        let daySelectHtml = '';
        let hourSelectHtml = '';

        for (const day of Object.keys(days)) {
            if (days[day] === rule_day) {
                daySelectHtml += `<option value="${days[day]}" selected="selected">${day}</option>`
            } else {
                daySelectHtml += `<option value="${days[day]}">${day}</option>`
            }
        }

        for (const hour of Object.keys(hours)) {
            if (hours[hour] === rule_hour) {
                hourSelectHtml += `<option value="${hours[hour]}" selected="selected">${hour}</option>`
            } else {
                hourSelectHtml += `<option value="${hours[hour]}">${hour}</option>`
            }
        }
        return {
            daySelectHtml,
            hourSelectHtml
        }
    }

    async function save_crontab_rule() {
        let start_day_of_week = $("#start_day_of_week").val();
        let start_hour_of_day = $("#start_hour_of_day").val();
        let end_day_of_week = $("#end_day_of_week").val();
        let end_hour_of_day = $("#end_hour_of_day").val();

        if (!(start_day_of_week && start_hour_of_day && end_day_of_week && end_hour_of_day)) {
            alert('请选择定时配置起始时间');
            return;
        }

        start_hour_of_day = Number(start_hour_of_day);
        start_day_of_week = Number(start_day_of_week);
        end_day_of_week = Number(end_day_of_week);
        end_hour_of_day = Number(end_hour_of_day);
        if (start_day_of_week === end_day_of_week && start_hour_of_day >= end_hour_of_day) {
            alert('起始时间不合法, 请重新选择');
            return;
        }

        let crontab_rule = {
            start: {
                day: start_day_of_week,
                hour: start_hour_of_day
            },
            end: {
                day: end_day_of_week,
                hour: end_hour_of_day
            }
        };

        const platform = $("#platform_input").val();
        const plan = CurrentPlan;
        if (!platform || !plan) {
            alert('lack plan or platform');
            return
        }
        console.log(crontab_rule);
        let username = localStorage.getItem("username");
        $.ajax({
            type: "POST",
            url: "/api/v1/cron_diff_config/config?username=" + username + "&menuId=setting",
            data: {
                platform,
                plan,
                setting_name: 'crontab_rule',
                setting_value: JSON.stringify(crontab_rule)
            },
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("提交失败：" + data.err);
                }
                alert('change success');
                refresh_crontab_rule();
            },
            error: function (req, status, err) {
                const message = err.message || err;
                alert("保存定时规则失败，网络出问题了，请稍后重试。错误原因:" + message);
                refresh_crontab_rule();
            },
        });
    }

    function onSearchPlatformAutoComplete (txt) {
        const filterPlatforms = allPlatformList.filter((platform) => {
            return platform.toLowerCase().indexOf(txt.toLowerCase()) > -1;
        });
        setPlatformAutoComplete(filterPlatforms.map((platform) => {
            return {value: platform};
        }));
    }

    return (
        <div id="crontab-special-config-component">
            <div className="page-wrapper" style={{overflowAnchor: 'none', marginTop: '20px'}}>
                <div className="row page-titles">
                    <div className="col-md-5 align-self-center">
                        <h3 className="text-info" style={{display: 'inline-block'}}>
                            差异化配置-定时器
                        </h3>
                        {/*<input id="platform_input" type="text" className="form-control input-rounded" placeholder="platform"*/}
                        {/*       style={{height: 30, width: 200, fontSize: 'small', position: 'absolute', left: 500, top: 3}}/>*/}
                        <AutoComplete
                            options={platformAutoComplete}
                            style={{
                                width: 250,
                                left: 200
                            }}
                            id="platform_input"
                            onSearch={onSearchPlatformAutoComplete}
                            placeholder="platform"
                        />
                        <button id="btn_refresh" className="btn btn-info btn-flat m-b-10 " type="button"
                                style={{width:40, height: 35, position: 'absolute', left: 750, top: 5}} onClick={refresh.bind(this)}>
                            <i className="fa fa-refresh"/>
                        </button>
                    </div>

                    <div className="col-md-7 align-self-center">
                    </div>
                </div>

                <div className="container-fluid" style={{overflowX: 'scroll'}}>
                    <ul className="nav nav-tabs customtab2" role="tablist">
                        <li className="nav-item">
                            <a className="nav-link active show" data-toggle="tab"
                               id="different_config_group_tab" href="#op_different_setting_group"
                               role="tab" aria-selected="false">
					<span className="hidden-xs-down" style={{fontSize: 'small'}}>
										用户分组
									</span>
                            </a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link " data-toggle="tab" id="crontab_rule" href="#op_crontab_rule"
                               role="tab" aria-selected="false">
					<span className="hidden-xs-down" style={{fontSize: 'small'}}>
										定时规则
									</span>
                            </a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link " data-toggle="tab" id="switch_tab" href="#op_switch_btn"
                               role="tab" aria-selected="false">
					<span className="hidden-xs-down" style={{fontSize: 'small'}}>
										开关
									</span>
                            </a>
                        </li>

                    </ul>
                    <div className="tab-content" style={{minWidth: 1296}}>

                        <div className="tab-pane p-20 active show" id="op_different_setting_group" role="tabpanel"
                             style={{overflowX: 'hidden', overflowY: 'hidden'}}>
                            <div id="different_config_group" className="col">
                                <div id="userGroupSelect" className="row" style={{width: '70%', marginLeft: 20}}>
                                    <div className="card" style={{width: '100%', position: 'relative'}}>
                                        <div style={{height: 50}}>
                                            af_status: <input className="combox"
                                                              style={{position: 'absolute', left: 300, width: 400}}
                                                              name="af_status" id="combox1" autoComplete="off"/>
                                        </div>
                                        <div style={{height: 50}}>
                                            media_source: <input className="combox"
                                                                 style={{position: 'absolute', left: 300, width: 400}}
                                                                 name="media_source" id="combox3" autoComplete="off"/>
                                        </div>
                                        <div style={{height: 50}}>
                                            campain_id: <input className="combox"
                                                               style={{position: 'absolute', left: 300, width: 400}}
                                                               name="campain_id" id="combox2" autoComplete="off"/>
                                        </div>
                                        <div style={{height: 50}}>
                                            country: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;<input
                                            type="radio" defaultChecked="checked" name="country_t" value="positive"/> 正选 &nbsp;
                                            <input type="radio" name="country_t" value="negative"/> 反选 <input
                                            className="combox" style={{position: 'absolute', left: 300, width: 400}}
                                            name="country" id="combox4" autoComplete="off"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{width: '70%', marginLeft: 20}}>
                                    <div className="card" style={{width: '100%', height: 80, position: 'relative'}}>
                                        <div className="row">
                                            <button id="submit_different_setting_user_group"
                                                    className="btn btn-info btn-flat m-b-10 " type="button"
                                                    style={{width: 80, height: 40, position: 'absolute', left: 400}}
                                                    onClick={save_diff_setting_user_group.bind(this)}>
                                                保存
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="tab-pane p-20" id="op_crontab_rule" role="tabpanel"
                             style={{overflowX: 'hidden', overflowY: 'hidden'}}>
                            <div id="crontab_rule_container" className="col">
                                <div id="crontab_rule_select" className="row" style={{width: '70%', marginLeft: 20}}>
                                </div>
                                <div className="row" style={{width: '70%', marginLeft: 20}}>
                                    <div className="card" style={{width: '100%', height: 80, position: 'relative'}}>
                                        <div className="row">
                                            <button id="submit_crontab_rule" className="btn btn-info btn-flat m-b-10 "
                                                    type="button"
                                                    style={{width:80, height: 40, position: 'absolute', left: 400 }}
                                                    onClick={save_crontab_rule.bind(this)}>
                                                保存
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="tab-pane p-20" id="op_switch_btn" role="tabpanel"
                             style={{overflowX: 'hidden', overflowY: 'hidden'}}>
                            <div id="switch_mod" style={{display: 'none'}} className="col">
                                <div id="confirm" className="row" style={{width: '70%', marginLeft: 20}}>

                                </div>
                                <div className="row" style={{width: '70%', marginLeft: 20}}>
                                    <div className="card" style={{width: '100%', height: 80, position: 'relative'}}>
                                        <div className="row">
                                            <button onClick={switchStatus.bind(this)} className="btn btn-info btn-flat m-b-10 "
                                                    type="button"
                                                    style={{width:100, position: 'absolute', left: '45%'}}>
                                                <span id="switch-text">已停用</span>
                                                <i id="switch-icon" className="fa fa-toggle-off">
                                                </i>
                                                <input type="hidden" id="switch" value="off"/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default CrontabDifferentSetting;

